// utils/parseContentToFields.ts

import { FieldConfig } from '../types/core/JsonParse';

export function parseContentToFields(
    content: Array<{ key: string; label: string; value: any }>
): FieldConfig[] {
    return content.map(item => {
        const type = detectType(item.value);

        const field: FieldConfig = {
            key: item.key,
            label: item.label || item.key,
            type: type,
            value: item.value,
        };

        // 🔥 Si c'est une liste d'objets, on parse les enfants
        if (type === 'list' && Array.isArray(item.value) && item.value.length > 0) {
            const firstItem = item.value[0];
            if (typeof firstItem === 'object' && firstItem !== null && !Array.isArray(firstItem)) {
                // 🔥 Les enfants sont les clés du premier objet
                field.children = Object.keys(firstItem).map(key => ({
                    key: key,
                    label: key,
                    type: detectType(firstItem[key]),
                    value: firstItem[key],
                }));
            }
        }

        // 🔥 Si c'est un objet, on parse ses enfants
        if (type === 'object' && typeof item.value === 'object' && item.value !== null && !Array.isArray(item.value)) {
            field.children = Object.entries(item.value).map(([key, val]) => ({
                key: key,
                label: key,
                type: detectType(val),
                value: val,
            }));
        }

        return field;
    });
}

function detectType(value: any): FieldConfig['type'] {
    if (Array.isArray(value)) {
        // Vérifier si c'est une liste d'objets
        if (value.length > 0 && typeof value[0] === 'object' && value[0] !== null && !Array.isArray(value[0])) {
            return 'list';
        }
        return 'list';
    }
    if (typeof value === 'object' && value !== null) return 'object';
    if (typeof value === 'string') {
        if (value.startsWith('http') && /\.(jpg|jpeg|png|gif|webp|svg)/i.test(value)) return 'image';
        if (value.length > 100) return 'textarea';
        return 'text';
    }
    if (typeof value === 'number') return 'number';
    if (typeof value === 'boolean') return 'boolean';
    return 'text';
}